var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInjuryHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_9",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#060606;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.33,16.11,16,6.2l-.52-.53a6.94,6.94,0,0,0-7.6-1.52A7.09,7.09,0,0,0,5.65,5.67h0a7,7,0,0,0,0,9.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.27,20.74l-.65-.65L19.92,30l.48.48a6.91,6.91,0,0,0,4.9,2.09h.08a6.9,6.9,0,0,0,6.92-6.92A7,7,0,0,0,31.77,23,6.88,6.88,0,0,0,30.27,20.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.68,8a6.75,6.75,0,0,0-1.51-2.25,7.09,7.09,0,0,0-2.26-1.52,6.91,6.91,0,0,0-7.6,1.53L5.57,20.82a6.94,6.94,0,0,0-2.08,5A6.92,6.92,0,0,0,4,28.49a6.84,6.84,0,0,0,1.55,2.28,6.94,6.94,0,0,0,4.87,2h.08a6.94,6.94,0,0,0,4.9-2.08L30.17,15.6a6.9,6.9,0,0,0,1.51-2.26,7,7,0,0,0,0-5.33ZM15,19.18a1.17,1.17,0,0,1-1.65,0,1.17,1.17,0,0,1,0-1.66,1.17,1.17,0,0,1,2,.83A1.17,1.17,0,0,1,15,19.18Zm3.46,3.45a1.16,1.16,0,0,1-.83.35,1.18,1.18,0,0,1-1.17-1.17,1.17,1.17,0,0,1,.34-.83,1.21,1.21,0,0,1,1.66,0h0A1.18,1.18,0,0,1,18.42,22.63Zm.39-3.85a1.18,1.18,0,0,1-.83.35,1.17,1.17,0,1,1,.83-2h0A1.16,1.16,0,0,1,18.81,18.78Zm.39-3.85a1.15,1.15,0,0,1-.82.34,1.17,1.17,0,0,1-.83-2,1.2,1.2,0,0,1,1.65,0,1.15,1.15,0,0,1,0,1.65Zm3.46,3.46A1.17,1.17,0,0,1,21,16.74a1.18,1.18,0,0,1,1.65,0,1.17,1.17,0,0,1,0,1.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjuryHistory);
export default __webpack_public_path__ + "static/media/injury-history.b38ac9ee700d4a39c4c567dc6f307740.svg";
export { ForwardRef as ReactComponent };